// actions.ts
import { Context, IActions } from './actions.types'
import { RootState } from '@/store/types'
import { ITechnicalReportData, Notification, INotification, TechnicalReport, ITechnicalReport } from '@/entities'
import { ActionTree } from 'vuex';
import { AppConstants as _app } from '@/shared/app.constants'
import router from '@/router/index'


export const actions: IActions = {
   
    /** get the communication data */
    getCommunication(context: Context, id: number): any {
        if(id) {         
            return this.$services.communication.getCommunication(id)
            .then((data: any) => {
                context.commit('setCommunication', { comm: data });
                return data;
            }).catch((e) => {
                context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
            });
        }
    },

    /** update the communication report */
    updateReport(context: Context, report: any): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.communication.updateReport(report)
        .then((resp) => {
            context.commit('setReportData', report );
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** save the Communication */
    saveCommunication(context: Context, comm: any): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.communication.updateCommunication(comm)
        .then((resp) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** save the Communication */
    startCommunication(context: Context, payload: any): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.communication.startCommunication(payload.nextStepId, payload.data)
        .then((resp) => {
            context.commit('application/updateOverlay', false, { root: true });
            if(resp.Result === 'OK') {
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
                router.push({
                    name: "communicationReports",
                    params: { communicationId: payload.data.GrantCommunicationId }
                });
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, text: resp.Message, color: 'error' } as INotification),  { root: true });
                
            }
            
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** return the report */
    returnReport(context: Context,  report: any): any {
        context.commit('application/updateOverlay', true, { root: true });

        this.$services.communication.returnReport(report)
        .then((resp) => {
            if(resp.Record && resp.Record.ValidationMessages && resp.Record.ValidationMessages.length > 0){
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: resp.Record.ValidationMessages.join('<br/>'), color: 'error' } as INotification),  { root: true });
            } else {
                context.commit('setCommunicationData', { comm: resp.Record });
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Record returned successfully', color: 'success' } as INotification),  { root: true });         
            } 
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** submit the communication report */
    submitReport(context: Context, report: any): any {
        context.commit('application/updateOverlay', true, { root: true });

        // report.Status = _app.commReportStatus.completed;
        return this.$services.communication.submitReport(report)
        .then((resp) => {
            if(resp.Record && resp.Record.ValidationMessages && resp.Record.ValidationMessages.length > 0){
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: resp.Record.ValidationMessages.join('<br/>'), color: 'error' } as INotification),  { root: true });
            } else {
                context.commit('setCommunicationData', { comm: resp.Record });
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
            }            
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** submit the communication report */
    reSubmitReport(context: Context, report: any): any {
        context.commit('application/updateOverlay', true, { root: true });

        // report.Status = _app.commReportStatus.completed;
        return this.$services.communication.reSubmitReport(report)
        .then((resp) => {
            if(resp.Record && resp.Record.ValidationMessages && resp.Record.ValidationMessages.length > 0){
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: resp.Record.ValidationMessages.join('<br/>'), color: 'error' } as INotification),  { root: true });
            } else {
                context.commit('setCommunicationData', { comm: resp.Record });
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
            }            
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    /** upload the document */
    uploadDocument(context: Context, payload: any) {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.document.uploadDocument(payload.file, payload.schema, payload.transactionId || context.state.communication.GrantCommunicationId, payload.language, payload.multiple)
        .then((resp) => {
            context.commit('application/updateOverlay', false, { root: true });
            return resp;
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        })
    },

    /** open the guidelines document */
    openGuidelines(context: Context, payload: any) {
        if(!payload) {
            context.commit('application/setNotification', new Notification({ snack: true, text: 'Guidelines document not found.', color: 'error' } as INotification),  { root: true });
        } else {
            this.$services.document.openExternalFile(payload)
            .catch((e) => {
                context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
            });        
        }
    }
}